export const DOC_BUILDER_SET_LOADING = "DOC_BUILDER_SET_LOADING";
export const DOC_BUILDER_SET_ERROR = "DOC_BUILDER_SET_ERROR";
export const DOC_BUILDER_SET_DOCUMENTS = "DOC_BUILDER_SET_DOCUMENTS";
export const DOC_BUILDER_ADD_DOCUMENT = "DOC_BUILDER_ADD_DOCUMENT";
export const DOC_BUILDER_REMOVE_DOCUMENT = "DOC_BUILDER_REMOVE_DOCUMENT";
export const DOC_BUILDER_SET_CURRENT_DOC = "DOC_BUILDER_SET_CURRENT_DOC";
export const DOC_BUILDER_UPDATE_DOCUMENT = "DOC_BUILDER_UPDATE_DOCUMENT";

export const DOC_BUILDER_BUILD_STATUS = "DOC_BUILDER_BUILD_STATUS";
export const DOC_BUILDER_PAGE_BUILT = "DOC_BUILDER_PAGE_BUILT";
export const DOC_BUILDER_BUILD_DONE = "DOC_BUILDER_BUILD_DONE";
export const DOC_BUILDER_BUILD_ERROR = "DOC_BUILDER_BUILD_ERROR";
export const DOC_BUILDER_BUILD_RESET = "DOC_BUILDER_BUILD_RESET";

export const DOC_BUILDER_UPDATE_PAGE = "DOC_BUILDER_UPDATE_PAGE";
export const DOC_BUILDER_ADD_PAGE = "DOC_BUILDER_ADD_PAGE";
export const DOC_BUILDER_REMOVE_PAGE = "DOC_BUILDER_REMOVE_PAGE";
export const DOC_BUILDER_REORDER_PAGES = "DOC_BUILDER_REORDER_PAGES";
export const DOC_BUILDER_ADD_SECTION = "DOC_BUILDER_ADD_SECTION";
export const DOC_BUILDER_UPDATE_SECTION = "DOC_BUILDER_UPDATE_SECTION";
export const DOC_BUILDER_REMOVE_SECTION = "DOC_BUILDER_REMOVE_SECTION";
export const DOC_BUILDER_MOVE_SECTION = "DOC_BUILDER_MOVE_SECTION";
export const DOC_BUILDER_RESET = "DOC_BUILDER_RESET";

// Undo/Redo actions
export const DOC_BUILDER_UNDO = "DOC_BUILDER_UNDO";
export const DOC_BUILDER_REDO = "DOC_BUILDER_REDO";

export const DOC_BUILDER_AI_EDIT_STATUS = "DOC_BUILDER_AI_EDIT_STATUS";
export const DOC_BUILDER_AI_EDIT_DONE = "DOC_BUILDER_AI_EDIT_DONE";
export const DOC_BUILDER_AI_EDIT_ERROR = "DOC_BUILDER_AI_EDIT_ERROR";
export const DOC_BUILDER_AI_EDIT_RESET = "DOC_BUILDER_AI_EDIT_RESET";

// Chat history (per-doc)
export const DOC_BUILDER_SET_CHAT_LIST = "DOC_BUILDER_SET_CHAT_LIST";
export const DOC_BUILDER_CHAT_UPSERT_LIST_ITEM =
  "DOC_BUILDER_CHAT_UPSERT_LIST_ITEM";
export const DOC_BUILDER_SET_CURRENT_CHAT_ID =
  "DOC_BUILDER_SET_CURRENT_CHAT_ID";
export const DOC_BUILDER_CHAT_CLEAR_SESSION = "DOC_BUILDER_CHAT_CLEAR_SESSION";

// Plan mode
export const DOC_BUILDER_PLAN_SET = "DOC_BUILDER_PLAN_SET";
export const DOC_BUILDER_PLAN_APPEND = "DOC_BUILDER_PLAN_APPEND";
export const DOC_BUILDER_PLAN_STATUS = "DOC_BUILDER_PLAN_STATUS";
export const DOC_BUILDER_PLAN_BUILD_DONE = "DOC_BUILDER_PLAN_BUILD_DONE";
export const DOC_BUILDER_PLAN_RESET = "DOC_BUILDER_PLAN_RESET";

// Chat messages
export const DOC_BUILDER_CHAT_SET_MESSAGES = "DOC_BUILDER_CHAT_SET_MESSAGES";
export const DOC_BUILDER_CHAT_ADD_MESSAGE = "DOC_BUILDER_CHAT_ADD_MESSAGE";
export const DOC_BUILDER_CHAT_UPDATE_MESSAGE =
  "DOC_BUILDER_CHAT_UPDATE_MESSAGE";
export const DOC_BUILDER_CHAT_RESET = "DOC_BUILDER_CHAT_RESET";
